import { FC, useRef } from 'react';
import Page, { PageProps } from '../../components/page';
import { Box, Stack } from '@mui/material';
import DataTable, { DataTableInstance } from '../../components/data-table';
import PageHeader from '../../components/page/header';
import PageBlurb from '../../components/page/blurb';
import useDrawer from '@/hooks/use-drawer.hook';
import { DtColumn, DtSort } from '@/components/data-table/helpers';
import OpenDrawerButton from '@/components/drawers/open-drawer-button';
import { getPartners } from '@/lib/services/partner.service';
import { QueryKey } from '@/lib/query-client';
import Chip from '@/components/chip';
import Button from '@/components/button';
import DomSize from '@/components/dom-size';

const columns: DtColumn[] = [
  { name: 'name', label: 'Name', flex: 2, sortable: true },
  { name: 'domains', label: 'Domains', flex: 2.5, sortable: false },
  { name: 'action', label: '', sortable: false },
];

const AdminPartnersPage: FC<PageProps> = () => {
  const { openDrawer } = useDrawer();

  const dtRef = useRef<DataTableInstance>(null);

  const handleRefresh = () => {
    dtRef.current?.refresh();
  };

  const handleOpenDrawer = (partnerId?: string) => {
    openDrawer('partner', { id: partnerId || null, onChange: handleRefresh });
  };

  const loadData = async (page: number, pageSize: number, sort?: DtSort) => {
    const dataset = await getPartners(page, pageSize, sort);

    return {
      ...dataset,
      rows: dataset.rows.map(({ id, name, domains }) => {
        return {
          id,
          name: <Box maxWidth="100%">{name}</Box>,
          domains: (
            <Stack gap={0.5} direction="row">
              {domains.map((domain) => (
                <Chip key={domain} label={domain} size="small" />
              ))}
            </Stack>
          ),
          action: (
            <Box width="100%" display="flex" justifyContent="flex-end">
              <OpenDrawerButton onClick={() => handleOpenDrawer(id)} />
            </Box>
          ),
        };
      }),
    };
  };

  return (
    <Page title="Partners">
      <PageHeader>
        <PageBlurb>
          Create a new partner, and view and change permissions for existing partners.
        </PageBlurb>
        <Button label="Add Partner" icon="plus" size="small" onClick={() => handleOpenDrawer()} />
      </PageHeader>

      <DomSize>
        <DataTable
          queryKey={QueryKey.PartnerDataset}
          columns={columns}
          onLoad={loadData}
          ref={dtRef}
          search={false}
          sort={{ columnName: 'name', direction: 'asc' }}
        />
      </DomSize>

    </Page>
  );
};

export default AdminPartnersPage;
